export default "__VITE_ASSET__B_uOTrvs__"